/*
 * Parameter Messages
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  shape: {
    id: 'cwt.translations.PlanPage.MainShape.Title',
    defaultMessage: 'Basic shape',
  },
  measurements: {
    id: 'cwt.translations.PlanPage.PlanPage.Measurements',
    defaultMessage: 'measurements',
  },
  wallLocation: {
    id: 'cwt.translations.PlanPage.WallLocation.Title',
    defaultMessage: 'Wall location',
  },  
  adjoiningHighCabinet: {
    id: 'cwt.translations.PlanPage.AdjoiningHighCabinet.Title',
    defaultMessage: 'Adjoining cabinets',
  },  
  kitchenIsland: {
    id: 'cwt.translations.kitchenIsland',
    defaultMessage: 'Kitchen island',
  },
  overhangType: {
    id: 'cwt.translations.PlanPage.OverhangType.Title',
    defaultMessage: 'Overhang type',
  },
  material: {
    id: 'cwt.translations.StylePage.Material.Title',
    defaultMessage: 'Material',
  },
  expression: {
    id: 'cwt.translations.StylePage.Expression.Title',
    defaultMessage: 'Expression',
  },
  coverpanel: {
    id: 'cwt.translations.StylePage.CoverPanel.Title',
    defaultMessage: 'Built up material',
  },
  edge: {
    id: 'cwt.translations.StylePage.Edge.Title',
    defaultMessage: 'Edge option',
  },
  thickness: {
    id: 'cwt.translations.StylePage.Thickness.Title',
    defaultMessage: 'Worktop thickness',
  },
  splashback: {
    id: 'cwt.translations.StylePage.Splashback.Title',
    defaultMessage: 'Splashback',
  },
  wallPanelMaterial: {
    id: 'cwt.translations.StylePage.WallPanelMaterial.Title',
    defaultMessage: 'Wall panel material',
  },
  wallPanelExpression: {
    id: 'cwt.translations.StylePage.WallPanelExpression.Title',
    defaultMessage: 'Wall panel expression',
  },
  sinkMaterial: {
    id: 'cwt.translations.SinkPage.SinkMaterial.Title',
    defaultMessage: 'Sink material',
  },
  sinkModel: {
    id: 'cwt.translations.SinkPage.SinkModel.Title',
    defaultMessage: 'Model',
  },
  sinkFastening: {
    id: 'cwt.translations.SinkPage.SinkFastening.Title',
    defaultMessage: 'Fastening',
  },
  drainerGrooves: {
    id: 'cwt.translations.SinkPage.DrainerGrooves.Title',
    defaultMessage: 'Drainer grooves',
  },
  tapHoles: {
    id: 'cwt.translations.SinkPage.TapHoles.Title',
    defaultMessage: 'Tap holes',
  },
  cutoutsForHob: {
    id: 'cwt.translations.CutoutsPage.CutoutsForHob.Title',
    defaultMessage: 'Cut-outs for hob',
  },
  freestandingHob: {
    id: 'cwt.translations.CutoutsPage.FreestandingHob.Title',
    defaultMessage: 'Freestanding cooker',
  },
  singleCuts: {
    id: 'cwt.translations.CutoutsPage.SingleCuts.Title',
    defaultMessage: 'Single cuts',
  },
  doubleCuts: {
    id: 'cwt.translations.CutoutsPage.DoubleCuts.Title',
    defaultMessage: 'Double cuts',
  },
  tripleCuts: {
    id: 'cwt.translations.CutoutsPage.TripleCuts.Title',
    defaultMessage: 'Triple cuts',
  },
  highCabinetJoints: {
    id: 'cwt.translations.PlanPage.HighCabinetJoints.Title',
    defaultMessage: 'Adjoining high cabinets',
  },
  roundedCorners: {
    id: 'cwt.translations.CutoutsPage.RoundedCorners.Title',
    defaultMessage: 'Rounded corners',
  },
  invertedCorners: {
    id: 'cwt.translations.CutoutsPage.InvertedCorners.Title',
    defaultMessage: 'Inverted corners',
  },
  roundCutsSmall: {
    id: 'cwt.translations.CutoutsPage.RoundCutsSmall.Title',
    defaultMessage: 'Round cuts (6-65mm)',
  },
  roundCutsBig: {
    id: 'cwt.translations.CutoutsPage.RoundCutsBig.Title',
    defaultMessage: 'Round cuts (65mm+)',
  },
  roundCutsSmallImperial: {
    id: 'cwt.translations.CutoutsPage.RoundCutsSmall.TitleImperial',
    defaultMessage: 'Round cuts (0.24-2.56 inches)',
  },
  roundCutsBigImperial: {
    id: 'cwt.translations.CutoutsPage.RoundCutsBig.TitleImperial',
    defaultMessage: 'Round cuts (2.56 inches+)',
  },
  squareCuts: {
    id: 'cwt.translations.CutoutsPage.SquareCuts.Title',
    defaultMessage: 'Square cuts (65mm+)',
  },
  squareCutsImperial: {
    id: 'cwt.translations.CutoutsPage.SquareCuts.TitleImperial',
    defaultMessage: 'Square cuts (2.56 inches+)',
  },
  cutout: {
    id: 'cwt.translations.KitchenIslandPage.SquareCuts.Title',
    defaultMessage: 'Square cuts',
  },
  kitchenIslandMaterial: {
    id: 'cwt.translations.KitchenIslandPage.KitchenIslandMaterial.Title',
    defaultMessage: 'Kitchen island material',
  },
  kitchenIslandWallLocation: {
    id: 'cwt.translations.KitchenIslandPage.kitchenIslandWallLocation.Title',
    defaultMessage: 'Kitchen island wall location',
  },
  kitchenIslandSplashback: {
    id: 'cwt.translations.KitchenIslandPage.kitchenIslandSplashback.Title',
    defaultMessage: 'Kitchen island splashback',
  },
  kitchenIslandExpression: {
    id: 'cwt.translations.KitchenIslandPage.KitchenIslandExpression.Title',
    defaultMessage: 'Kitchen island expression',
  },
  kitchenIslandCoverpanel: {
    id: 'cwt.translations.KitchenIslandPage.KitchenIslandCoverPanel.Title',
    defaultMessage: 'Built up material',
  },
  kitchenIslandEdge: {
    id: 'cwt.translations.KitchenIslandPage.KitchenIslandEdge.Title',
    defaultMessage: 'Kitchen island edge',
  },
  kitchenIslandThickness: {
    id: 'cwt.translations.KitchenIslandPage.KitchenIslandThickness.Title',
    defaultMessage: 'Kitchen island thickness',
  },
  kitchenIslandOverhang: {
    id: 'cwt.translations.KitchenIslandPage.kitchenIslandWaterfall.Title',
    defaultMessage: 'Kitchen island waterfall',
  },
  kitchenIslandWaterfallSide: {
    id: 'cwt.translations.KitchenIslandPage.kitchenIslandWaterfallSide.Title',
    defaultMessage: 'Kitchen island waterfall side',
  },
  kitchenIslandCutouts: {
    id: 'cwt.translations.KitchenIslandPage.kitchenIslandCutouts.Title',
    defaultMessage: 'Kitchen island cut-outs',
  },
  overhangSide: {
    id: 'cwt.translations.PlanPage.OverhangSide.Title',
    defaultMessage: 'Overhang side',
  },
  kitchenIslandOverhangSide: {
    id: 'cwt.translations.KitchenIslandPage.OverhangSide.Title',
    defaultMessage: 'Kitchen island overhang side',
  },
  wallEdgingStripMaterial: {
    id: 'cwt.translations.StylePage.wallEdgingStripMaterial.Title',
    defaultMessage: 'Wall edging strip for which worktop material?',
  },
});
